/* Read native selections; never write a variant, upload, quantity or cart property. */
(() => {
  const sizes = {
    '59423849709913': { key: 'small', label: '20 × 40 cm', inches: '7.9 × 15.7″' },
    '59423849742681': { key: 'medium', label: '40 × 60 cm', inches: '15.7 × 23.6″' },
    '59423849775449': { key: 'large', label: '60 × 80 cm', inches: '23.6 × 31.5″' }
  };
  if (!customElements.get('fiorpaw-pillow-examples')) {
    customElements.define('fiorpaw-pillow-examples', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const gallery = this.closest('media-gallery');
        if (!gallery) return;
        gallery.addEventListener('click', event => {
          const example = event.target.closest('button[data-pet-example]');
          if (example && this.contains(example)) {
            const key = example.dataset.petExample;
            this.querySelectorAll('[data-pet-panel]').forEach(panel => { panel.hidden = panel.dataset.petPanel !== key; });
            this.querySelectorAll('[data-pet-example]').forEach(button => button.setAttribute('aria-pressed', String(button === example)));
            return;
          }
          const toggle = event.target.closest('button[data-pillow-examples],button[data-pillow-media]');
          if (!toggle || !gallery.contains(toggle)) return;
          const show = toggle.hasAttribute('data-pillow-examples');
          this.hidden = !show;
          gallery.classList.toggle('fp-px-show-examples', show);
          gallery.querySelector('[data-pillow-examples]')?.setAttribute('aria-pressed', String(show));
          if (show) {
            gallery.querySelectorAll('[data-pillow-media]').forEach(button => button.setAttribute('aria-pressed', 'false'));
            if (window.matchMedia('(max-width:749px)').matches) this.scrollIntoView({ block: 'start', behavior: 'auto' });
          }
        }, { signal, capture: true });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('fiorpaw-pillow-size')) {
    customElements.define('fiorpaw-pillow-size', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const section = this.closest('product-information') || this.closest('.product-information') || this.closest('section');
        if (!section) return;
        const sync = event => {
          const target = event?.target;
          if (target && !target.closest?.('variant-picker')) return;
          const input = target?.matches?.('select') ? target.selectedOptions[0] : section.querySelector('variant-picker input:checked');
          const size = sizes[input?.dataset.variantId];
          if (size) this.paint(size);
        };
        const initial = Object.values(sizes).find(size => size.key === this.dataset.selected);
        if (initial) this.paint(initial);
        section.addEventListener('change', sync, { signal });
        sync();
      }
      paint(size) {
        this.dataset.selected = size.key;
        this.querySelector('[data-size-label]').textContent = size.label;
        const inches = /^(de|fr)\b/.test(document.documentElement.lang) ? size.inches.replace(/\./g, ',') : size.inches;
        this.querySelector('[data-size-inches]').textContent = `(≈ ${inches})`;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
})();
